export default __webpack_public_path__ + "static/7-5dee934f4bc92c7d3d985531c483eb8a.png";